import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileCTABar from "./components/MobileCTABar";
import AccessibilityWidget from "./components/AccessibilityWidget";
import { Toaster } from "./components/ui/toaster";

import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import SeoService from "./pages/SeoService";
import ServiceAreas from "./pages/ServiceAreas";
import ServiceArea from "./pages/ServiceArea";
import Gallery from "./pages/Gallery";
import Financing from "./pages/Financing";
import Faqs from "./pages/Faqs";
import Contact from "./pages/Contact";
import Estimate from "./pages/Estimate";
import Accessibility from "./pages/Accessibility";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Admin from "./pages/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function SiteChrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin");

  useEffect(() => {
    if (bare) return;
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="tel:"], a[href^="sms:"]');
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const kind = href.startsWith("sms:") ? "text" : "call";
      const source = a.getAttribute("data-call-source") || "page";
      const path = window.location.pathname;
      try {
        const body = JSON.stringify({ source, path, kind });
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/track/call`;
        if (navigator.sendBeacon) {
          navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
        } else {
          fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true });
        }
      } catch (_) {}
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, [bare]);

  if (bare) return <>{children}</>;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileCTABar />
      <AccessibilityWidget />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <SiteChrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/pool-screen-enclosures" element={<SeoService slug="pool-screen-enclosures" />} />
            <Route path="/screen-enclosures" element={<SeoService slug="screen-enclosures" />} />
            <Route path="/patio-porch-screen-enclosures" element={<SeoService slug="patio-porch-screen-enclosures" />} />
            <Route path="/pool-screen-repair-rescreening" element={<SeoService slug="pool-screen-repair-rescreening" />} />
            <Route path="/carports" element={<SeoService slug="carports" />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/service-areas/:city" element={<ServiceArea />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/financing" element={<Financing />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/estimate" element={<Estimate />} />
            <Route path="/accessibility-statement" element={<Accessibility />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </SiteChrome>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
